<script>
    export default {
        props: {
            headerLogo: String
        }
    } 
</script>

<template>
    <a href="https://seqwens.com/">
        <img
            :src="headerLogo"
            alt=""
            class="img-fluid p-2"
            style="
                display: block;
                margin-left: auto;
                margin-right: auto;
                height: 65px;
            "
        />
    </a>
</template>